import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { QUERY_PARAMS } from "@/routes/_constants/query-params";
import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

export const useGetResetPasswordVerifyParams = () => {
	const [canRender, setCanRender] = useState(false);

	const [searchParams] = useSearchParams();

	const navigate = useNavigate();

	const _verifyCode = searchParams.get(QUERY_PARAMS.AUTH.RESET_PASSWORD_VERIFY.VERIFY_CODE);
	const _email = searchParams.get(QUERY_PARAMS.AUTH.RESET_PASSWORD_VERIFY.USERNAME);

	useEffect(() => {
		if (!_verifyCode && !_email) {
			notifyUserEventInfo({
				title: "",
				description: "URLが正しくありません。メールを再度ご確認ください。",
			});

			navigate(PATHS.AUTH.FORGOT_PASSWORD);
		} else {
			setCanRender(true);
		}
	}, [navigate, _email, _verifyCode]);

	return {
		verifyCode: _verifyCode!,
		email: _email!,
		canRender,
	};
};
